export default {
	title: "Tipos de Rituais",
	spiritualLine: "Linha Espiritual",
	status: "Status",
	details: {
		basicInfo: "Informações Básicas",
		timestamps: "Informações do Sistema",
		noData: "Nenhum dado disponível",
	},
	edit: "Editar Tipo de Ritual",
	create: "Criar Tipo de Ritual",
	activate: "Ativar",
	deactivate: "Desativar",
	notFound: "Tipo de ritual não encontrado",
	deleteConfirmation: "Deseja realmente excluir o tipo de ritual {name}?",
	form: {
		nameLabel: "Nome do Tipo de Ritual",
		nameHint: "Nome que identifica o tipo de ritual",
		codeLabel: "Código",
		codeHint: "Preenchido a partir do nome — só mexa se quiser outro",
		descriptionLabel: "Descrição",
		descriptionHint: "Descrição opcional do tipo de ritual",
		spiritualLineLabel: "Linha Espiritual Predominante",
		spiritualLineHint: "Linha espiritual que predomina neste tipo de ritual",
		isActiveLabel: "Tipo ativo no sistema",
	},
	validation: {
		nameRequired: "Nome é obrigatório",
		nameMaxLength: "Nome deve ter no máximo 100 caracteres",
		codeRequired: "Código é obrigatório",
		codeMaxLength: "Código deve ter no máximo 50 caracteres",
		codeFormat: "Código deve conter apenas letras minúsculas, números, hífens e sublinhados",
		spiritualLineRequired: "Linha espiritual é obrigatória",
		descriptionMaxLength: "Descrição deve ter no máximo 500 caracteres",
	},
	messages: {
		created: "Tipo de ritual {name} criado com sucesso",
		updated: "Tipo de ritual {name} atualizado com sucesso",
		deleted: "Tipo de ritual {name} excluído com sucesso",
		deactivatedWithDeps: "Tipo de ritual {name} possui dependências e foi desativado",
		activated: "Tipo de ritual {name} ativado com sucesso",
		deactivated: "Tipo de ritual {name} desativado com sucesso",
		createError: "Erro ao criar tipo de ritual",
		updateError: "Erro ao atualizar tipo de ritual",
		deleteError: "Erro ao excluir tipo de ritual",
		loadError: "Erro ao carregar tipos de rituais",
		toggleError: "Erro ao alterar status do tipo de ritual",
	},
	noDescription: "Sem descrição",
	searchPlaceholder: "Nome, código ou descrição...",
	loading: "Carregando detalhes...",
	filters: {
		status: {
			all: "Todos",
		},
	},
	table: {
		name: "Nome",
		spiritualLine: "Linha Espiritual",
		attendanceCards: "Fichas",
		status: "Status",
		headers: {
			createdAt: "Criado em",
			updatedAt: "Atualizado em",
		},
	},
	empty: {
		title: "Nenhum tipo de ritual encontrado",
		description: "Cadastre os tipos de rituais praticados no templo",
	},
	stats: {
		total: "Tipos",
		active: "Ativos",
	},
};
